/** TanStack Query hook for current authenticated user */

import { useQuery } from '@tanstack/react-query'
import { apiClient, ApiError } from '../lib/api-client'
import type { Role } from '@agentwiki/shared'

interface AuthUser {
  id: string
  email: string
  name: string
  avatarUrl: string | null
  provider?: string
}

interface AuthMeResponse {
  user: AuthUser
  tenantId: string
  role: Role
}

export function useAuth() {
  const query = useQuery<AuthMeResponse, ApiError>({
    queryKey: ['auth', 'me'],
    queryFn: () => apiClient.get<AuthMeResponse>('/api/auth/me'),
    retry: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  return {
    user: query.data?.user ?? null,
    tenantId: query.data?.tenantId ?? null,
    role: query.data?.role ?? null,
    isLoading: query.isLoading,
    isAuthenticated: !!query.data,
    error: query.error,
    refetch: query.refetch,
  }
}
